// The Transactions slice's endpoints, injected into the one shared baseApi.
import { baseApi } from '@/lib/api/baseApi';
import { transactionsEndpoints } from './transactions.queries';

export const transactionsApi = baseApi.injectEndpoints({
  endpoints: (build) => transactionsEndpoints(build),
});

export const {
  useGetTransactionsQuery,
  useGetTransactionFilterOptionsQuery,
  useGetTransactionAttachmentsQuery,
} = transactionsApi;
